import React from "react"
import CustomButton from "../../../../../ui/atoms/Button"
import Typography from "../../../../../ui/atoms/Typography"
import { ArrowBackIcon } from "../../../../../ui/icons"
import classes from "./FiltersPanelHead.module.css"

interface Props {
  title: string
  onBackClick: () => void
  onRemoveClick: () => void
}

const FiltersPanelHead = ({ title, onBackClick }: Props) => {
  return (
    <div className={classes.root}>
      <div className={classes.title}>
        <Typography variant="body1">{title.toUpperCase()}</Typography>
      </div>
      <div className={classes.controls}>
        <CustomButton
          variant="text"
          onClick={onBackClick}
          invariantCase
          classes={{ inner: "flex items-center" }}
        >
          <ArrowBackIcon className={classes.back} />
          <Typography variant="body2" lineHeightValue="16px" component="span">
            Indietro
          </Typography>
        </CustomButton>
        {/* <CustomButton variant="text" onClick={onRemoveClick} invariantCase>
          <Typography variant="body1">Rimuovi filtri</Typography>
        </CustomButton> */}
      </div>
    </div>
  )
}

export default FiltersPanelHead
